//added by priya 20-02-2026
import { Component, Input, OnInit } from '@angular/core';
import { ApplicationStatus } from 'src/app/models';
import { WorkflowApplicationsJanusService } from 'src/app/views/admin/workflow-applications/workflow-applications-janus/workflow-applications-janus.service';



@Component({
  selector: 'app-application-summary-info',
  standalone: false,
  templateUrl: './application-summary-status.component.html',
  styleUrl: './application-summary-status.component.scss'
})
export class ApplicationSummaryStatusComponent implements OnInit {
  @Input({ required: false }) applicationNumber: string = '';
  @Input({ required: false }) userName: string = '';
  @Input() startedOn: string = '';
  @Input() status: ApplicationStatus | string | null = null;
    constructor(private workflowApplicationsJanusSvc: WorkflowApplicationsJanusService) {

  }
  ngOnInit(): void {
    this.workflowApplicationsJanusSvc.data$.subscribe((data) => {
      if (data.inlineApplicationSummaryDetails.updateUserNameAndAppNo === true) {
        this.applicationNumber = data.inlineApplicationSummaryDetails.combinedApplicationNumber
        this.userName = data.inlineApplicationSummaryDetails.userName
        setTimeout(() => {
          this.workflowApplicationsJanusSvc.setData({
            ...this.workflowApplicationsJanusSvc.getData(),
            inlineApplicationSummaryDetails: {
              ...this.workflowApplicationsJanusSvc.getData().inlineApplicationSummaryDetails,
              updateUserNameAndAppNo: false
            }
          })
        })
      }

    })
  }
  ApplicationStatus = ApplicationStatus;

  statusLabelMap: Record<string, string> = {
    'Complete': 'Complete',
    'Incomplete': 'Incomplete',
    'Action Needed': 'Action Needed',
    'In Progress': 'In Progress',
    'Voided': 'Voided'
  };

  statusStyleMap: Record<string, { bg: string; color: string }> = {
    'Complete': { bg: 'rgba(46, 125, 50, 1)', color: 'white' },
    'Incomplete': { bg: 'rgba(211, 47, 47, 1)', color: 'white' },
    'Action Needed': { bg: 'rgba(239, 108, 0, 1)', color: 'white' },
    'In Progress': { bg: 'rgba(33, 150, 243, 1)', color: 'white' },
    'Voided': { bg: 'rgba(189, 189, 189, 1)', color: 'white' }
  };
  statusLightStyleMap: Record<string, { bg: string }> = {
    'Complete': { bg: '#E8F5E9' },
    'Incomplete': { bg: '#c024242b' },
    'Action Needed': { bg: '#ff980033' },
    'In Progress': { bg: '#2196f333' },
    'Voided': { bg: '#E0E0E0' }
  };
  ApplicationStatusLabel: Record<ApplicationStatus, string> = {
    [ApplicationStatus.NotStarted]: 'Not Started',
    [ApplicationStatus.InProgress]: 'In Progress',
    [ApplicationStatus.Completed]: 'Completed',
    [ApplicationStatus.Voided]: 'Voided',
    [ApplicationStatus.Rejected]: 'Rejected',
    [ApplicationStatus.Discarded]: 'Discarded',
    [ApplicationStatus.Expired]: 'Expired',
    [ApplicationStatus.Locked]: 'Locked',
    [ApplicationStatus.Withdrawn]: 'Withdrawn',
    [ApplicationStatus.Migrating]: 'Migrating'
  };

  ApplicationStatusStyle: Record<
    ApplicationStatus,
    { bg: string; color: string }
  > = {
      [ApplicationStatus.NotStarted]: { bg: '#E0E0E0', color: 'white' },
      [ApplicationStatus.InProgress]: { bg: 'rgba(211, 47, 47, 1)', color: 'white' },
      [ApplicationStatus.Completed]: { bg: 'rgba(46, 125, 50, 1)', color: 'white' },
      [ApplicationStatus.Voided]: { bg: '#9E9E9E', color: 'white' },
      [ApplicationStatus.Rejected]: { bg: 'rgba(211, 47, 47, 1)', color: 'white' },
      [ApplicationStatus.Discarded]: { bg: '#9E9E9E', color: 'white' },
      [ApplicationStatus.Expired]: { bg: '#ff5722', color: 'white' },
      [ApplicationStatus.Locked]: { bg: '#9E9E9E', color: 'white' },
      [ApplicationStatus.Withdrawn]: { bg: '#9E9E9E', color: 'white' },
      [ApplicationStatus.Migrating]: { bg: '#9E9E9E', color: 'white' }
    };
  ApplicationStatusLightStyle: Record<
    ApplicationStatus,
    { bg: string }
  > = {
      [ApplicationStatus.NotStarted]: { bg: '#F5F5F5' },

      [ApplicationStatus.InProgress]: { bg: '#FDECEA' },

      [ApplicationStatus.Completed]: { bg: '#E8F5E9' },

      [ApplicationStatus.Voided]: { bg: '#E0E0E0' },

      [ApplicationStatus.Rejected]: { bg: '#FDECEA' },

      [ApplicationStatus.Discarded]: { bg: '#E0E0E0' },

      [ApplicationStatus.Expired]: { bg: '#FFF3E0' },

      [ApplicationStatus.Locked]: { bg: '#E0E0E0' },

      [ApplicationStatus.Withdrawn]: { bg: '#F3E5F5' },

      [ApplicationStatus.Migrating]: { bg: '#E0E0E0' }
    };
  get formattedStartedOn(): string {
    if (!this.startedOn) return '';

    const date = new Date(this.startedOn);
    const day = date.getDate();

    let suffix = 'th';
    if (day % 10 === 1 && day !== 11) suffix = 'st';
    else if (day % 10 === 2 && day !== 12) suffix = 'nd';
    else if (day % 10 === 3 && day !== 13) suffix = 'rd';

    const options: Intl.DateTimeFormatOptions = {
      weekday: 'long',
      month: 'long'
    };

    const formatted = date.toLocaleDateString('en-US', options);

    return `${formatted} ${day}${suffix}`;
  }

  get statusLabel(): string {
    if (!this.status) return '';

    // enum case
    if (typeof this.status === 'number') {
      return this.ApplicationStatusLabel[this.status];
    }

    // string case
    return this.statusLabelMap[this.status] || this.status;
  }

  get statusStyle() {
    if (!this.status) return null;

    if (typeof this.status === 'number') {
      return this.ApplicationStatusStyle[this.status];
    }

    return this.statusStyleMap[this.status] || null;
  }

  get statusBgStyle() {
    if (!this.status) return null;

    if (typeof this.status === 'number') {
      return this.ApplicationStatusLightStyle[this.status];
    }

    return this.statusLightStyleMap[this.status] || null;
  }
  get showStatusBadge(): boolean {
    if (!this.status) return false;

    if (typeof this.status === 'number') {
      return this.status >= ApplicationStatus.Completed;
    }
      return true;
  }
}
